import axios from 'axios';

const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

const cleanAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true, 
});

export const callConnectivityAPI = {
  initiateCallSession: async (data: { expertCode: string, categoryId: number | null, intakeData?: any }) => {
    const response = await cleanAxios.post('/api/session/initiate', {
      ...data,
      sessionType: 'call' 
    });
    return response.data;
  },

  leaveQueue: async (expertCode: string) => {
    const response = await cleanAxios.post('/api/session/leave-queue', { expertCode });
    return response.data;
  },

  // ==========================================
  // 🚨 AGORA CLOUD RECORDING ENDPOINTS
  // ==========================================

  startRecording: async (sessionId: string, data: { userCode: string; expertCode: string; intakeData?: any }) => {
    const response = await cleanAxios.post(`/api/session/${sessionId}/recording/start`, data);
    return response.data;
  },

  stopRecording: async (sessionId: string) => {
    const response = await cleanAxios.post(`/api/session/${sessionId}/recording/stop`);
    return response.data;
  }
};